<template>
  <!-- Need to use vshow as we are using a form field -->
  <div v-show="showPaymentInfo || editPaymentInfo">
    <TextField
      id="freedompay-terminal-id"
      :name="fieldName"
      :label="t('sites.singleSite.financialConfig.paymentInfo.form.freedomPayTerminalId')"
      :placeholder="
        t('sites.singleSite.financialConfig.paymentInfo.form.freedomPayTerminalIdPlaceholder')
      "
      :required="editPaymentInfo"
      :disabled="!editPaymentInfo"
    />
  </div>

  <div v-show="!showPaymentInfo && !editPaymentInfo">
    <Password
      id="freedompay-store-id"
      v-model="dummyValue"
      :placeholder="
        t('sites.singleSite.financialConfig.paymentInfo.form.freedomPayStoreIdPlaceholder')
      "
      :disabled="true"
      :required="editPaymentInfo"
    >
      <template #label>
        {{ t('sites.singleSite.financialConfig.paymentInfo.form.freedomPayTerminalId') }}
      </template>
    </Password>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { TextField } from '@centric-os/components/src/composed/validators/text-field';
import { Password } from '@centric-os/components/src/core/controls/password';
import { computed, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useFinancialConfigStore, usePaymentInfoStore } from '../../../../../../../routes';

// Set localization
const { t } = useI18n();

// Dummy ref
const dummyValue = ref<string>('*******');

// Set financial config store
const fConfigStore = useFinancialConfigStore();
const { editPaymentInfo, isStationInitialSetup } = storeToRefs(fConfigStore);

// Set payment info store
const paymentInfoStore = usePaymentInfoStore();
const { showPaymentInfo } = storeToRefs(paymentInfoStore);

const fieldName = computed<string>(() => {
  if (isStationInitialSetup.value) {
    return 'paymentConfig.paymentSettings.freedompay.freedompay_terminal_id';
  }
  return 'freedompay.freedompay_terminal_id';
});
</script>
